<!-- TEMPLATE -->
<template>
  <div :class='customerOverviewClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>{{ pageTitle }}</span>
            </span>
          <dean-section-title-item
            :icon='plusIcon'
            :content="true"
            @click.native="sectionRoute('customers.add')"
          >
            Klant Toevoegen
          </dean-section-title-item>
        </dean-section-title>
        <!-- TODO:  -->
        <div class="filter">
          <dean-form-row
            @input="update(true)"
            v-model="pageMeta.query"
            class="top-bar"
            hide-label="true"
          >zoek
          </dean-form-row>
          <dean-form-row
            @input="update"
            v-model="pageMeta.startDate"
            class="top-bar"
            hide-label="true"
            type="date"
          >startdatum
          </dean-form-row>
          <dean-form-row
            @input="update"
            v-model="pageMeta.endDate"
            class="top-bar"
            hide-label="true"
            type="date"
          >einddatum
          </dean-form-row>
          <button :class="{active: pageMeta.cloudService == true}" id="servicecloud">
            <dean-icon
              :glyph="deanCloudIcon"
              @click.native="pageMeta.cloudService = !pageMeta.cloudService; update()"
              width="20"
              height="20"
            ></dean-icon>
          </button>
          <b-tooltip target="servicecloud" placement="bottom">
            Cloud
          </b-tooltip>

          <button :class="{active: pageMeta.internetService == true}" id="serviceinternet">
            <dean-icon :glyph="deanInternetIcon"
                       @click.native="pageMeta.internetService = !pageMeta.internetService; update()"
                       width="20"
                       height="20"
            ></dean-icon>
          </button>
          <b-tooltip target="serviceinternet" placement="bottom">
            Connection
          </b-tooltip>

          <button :class="{active: pageMeta.mobileService == true}" id="servicemobile">
            <dean-icon :glyph="deanMobileOdidoIcon"
                       @click.native="pageMeta.mobileService = !pageMeta.mobileService; update()"
                       width="20"
                       height="20"
            ></dean-icon>
          </button>
          <b-tooltip target="servicemobile" placement="bottom">
            Odido Mobile
          </b-tooltip>

          <button :class="{active: pageMeta.mobileKpnService == true}" id="servicemobilekpn">
            <dean-icon :glyph="deanMobileKpnIcon"
                       @click.native="pageMeta.mobileKpnService = !pageMeta.mobileKpnService; update()"
                       width="20"
                       height="20"
            ></dean-icon>
          </button>
          <b-tooltip target="servicemobilekpn" placement="bottom">
            KPN Mobile
          </b-tooltip>

          <button :class="{active: pageMeta.sipTrunkService == true}" id="servicesiptrunk">
            <dean-icon :glyph="deanSipTrunkIcon"
                       @click.native="pageMeta.sipTrunkService = !pageMeta.sipTrunkService; update()"
                       width="20"
                       height="20"
            ></dean-icon>
          </button>
          <b-tooltip target="servicesiptrunk" placement="bottom">
            Sip Trunk
          </b-tooltip>
        </div>
        <dean-table
          :data='customerData'
          :columns='columns'
          :hover="true"
          @column-click='columnClick'
          @cell-click="cellClick"
        >
            <span slot="contractedServices" slot-scope="contractedServices">
              <dean-icon v-for="serviceIcon in contractedServices.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
        </dean-table>
        <dean-pagination
          :current-page='customerMetaData.pageNumber'
          :total-items='customerMetaData.totalResults'
          :items-per-page='customerMetaData.itemsPerPage'
          :select-items-per-page='selectItemsPerPage'
          :visible-pages='customerMetaData.visiblePages'
          @page-changed='paginationChanged'
          @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {servicesStringToIcons} from '@/mixins/stringToIcons';
  import {mixins} from 'vue-class-component';
  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
    deanCloudIcon,
    deanInternetIcon,
    customIconPhoneCall,
    customIconSmartphoneKpn,
    customIconSmartphoneOdido,
    deanButton,
  } from '@deanone/dean-components';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {BTooltip} from 'bootstrap-vue';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
      deanButton,
      deanFormRow,
      BTooltip,
    },
  })
  export default class List extends mixins(deanTableMixin) {

    public customers: object[] = [];
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public deanCloudIcon: object = deanCloudIcon;
    public deanInternetIcon: object = deanInternetIcon;
    public deanMobileOdidoIcon: object = customIconSmartphoneOdido;
    public deanMobileKpnIcon: object = customIconSmartphoneKpn;
    public deanSipTrunkIcon: object = customIconPhoneCall;
    public queryTimeout!: number;

    // COMPUTED
    get customerOverviewClass() {
      let value = 'customer-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get customerMetaData() {
      return this.pageMeta;
    }

    get customerData() {
      return this.customers;
    }

    get columns(): any {
      const columns: any = {
        code: {
          content: 'Klantnummer',
          align: 'left',
          sort: true,
          dql: 'code',
        },
        name: {
          content: 'Bedrijfsnaam',
          align: 'left',
          sort: true,
          dql: 'name',
        },
        pchsnr: {
          content: 'Pchsnr',
          align: 'left',
          sort: false, // TODO should be true
          dql: 'pchsnr',
        },
        city: {
          content: 'Plaats',
          align: 'left',
          sort: false, // TODO should be true
          dql: 'city',
        },
      };

      return {
        ...columns, ...{
          monthValueOrders: {
            content: 'Maandwaarde orders',
            align: 'left',
            dql: 'monthValueOrders',
          },
          contractedServices: {
            content: 'Diensten',
            type: 'slot',
            slot: 'contractedServices',
            align: 'center',
            dql: 'contractedServices',
          },
        },
      };
    }

    get pageTitle() {
      switch (this.$route.params.status) {
        case 'active':
          return 'Actief klanten';
        case 'inactive':
          return 'Inactief klanten';
        case 'end':
          return 'Archief klanten';
        default:
          return 'Klanten';
      }
    }

    // DATA
    get sideMenu(): object {
      return {
        content: {
          title: {
            text: 'Klanten',
            mobile: {
              close: {
                text: 'Close',
                icon: invoicesIcon,
              },
            },
          },
          type: 'themed',
          sections: {
            filters: {
              title: 'status',
              items: {
                summery: {
                  title: 'Overzicht',
                  icon: summeryIcon,
                  state: (this.$route.params.status === undefined ? 'active' : ''),
                  name: 'customers.overview',
                },
                active: {
                  title: 'Actief',
                  icon: summeryIcon,
                  name: 'customers.overview.status',
                  state: (this.$route.params.status === 'active' ? 'active' : ''),
                  params: {status: 'active'},
                },
                inactive: {
                  title: 'Inactief',
                  icon: summeryIcon,
                  name: 'customers.overview.status',
                  state: (this.$route.params.status === 'inactive' ? 'active' : ''),
                  params: {status: 'inactive'},
                },
                archived: {
                  title: 'Archief',
                  icon: summeryIcon,
                  name: 'customers.overview.status',
                  state: (this.$route.params.status === 'end' ? 'active' : ''),
                  params: {status: 'end'},
                },
              },
            },
          },
        },
      };
    }

    public tableName(): string {
      return 'customers';
    }

    public update(timeout: boolean) {
      this.pageMeta.pageNumber = 1;

      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 500);
      } else {
        this.loadList(meta);
      }
    }

    public cellClick(target: { cell: object, row: { id: string, partnerAgreementId: string }, column: string }) {
      this.$router.push({
        name: 'customers.edit',
        params: {id: target.row.id, paid: target.row.partnerAgreementId},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/customers.list', {
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        filter: data.query,
        sort: data.sort,
        status: this.$route.params.status,
        cloudService: data.cloudService,
        internetService: data.internetService,
        mobileService: data.mobileService,
        sipTrunkService: data.sipTrunkService,
        startDate: data.startDate,
        endDate: data.endDate,
      }).then(
        (response) => {
          this.customers = response.data.data.map((customer: any) => {
            return {
              id: customer.id,
              partnerAgreementId: customer.agreement,
              code: customer.code,
              name: customer.name,
              pchsnr: customer.address ? (customer.address.postalCode +
                  ' / ' +
                  customer.address.houseNumber + (
                      customer.address.houseNumberExtension ?
                          '-' + customer.address.houseNumberExtension :
                          ''
                  )
              ) : '-',
              city: customer.address ? customer.address.city : '-',
              monthValueOrders: new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
              }).format(customer.monthlyOrderValue),
              contractedServices: servicesStringToIcons(customer.services),
            };
          });
          this.updateMeta(response.data.meta);

          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.keepMetaSavedInState();
      this.setDefaultSort('name');
      if (this.$route.params.status) {
        this.pageMeta.status = this.$route.params.status;
      }

      this.loadList(this.pageMeta);
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';

  .filter {
    display: flex;
  }

  button {
    fill: var(--color-dark, $color-dark);
    background: none;
    padding: 5px;
    border: 0;
    margin: 5px;
    transition: fill .3s;
    border-radius: 5px;
  }

  button.active,
  button:hover {
    fill: var(--color-secondary, $color-secondary);
  }

  .top-bar {
    display: inline-block;
  }

  :deep(.top-bar .hd-6.columns) {
    width: 100%;
  }
</style>